import React from "react";

import BenefitsCards from "../../Components/BenefitsCards";

import { classNameGenerator } from "@/utils";

import styles from "./BenefitsForm.module.scss";
import { useAppSelector } from "@/hooks";

interface BenefitsFormProps {
  children: React.ReactNode;
}

const BenefitsForm: React.FC<BenefitsFormProps> = ({ children }) => {
  const cls = classNameGenerator(styles);
  const { data } = useAppSelector((state) => state.bootCamp);

  if(!data?.benefitsCards)
    return <></>
    
  return (
    <section className={cls("benefitFormSection")}>
      <div className={cls("container")}>
        <BenefitsCards />
        <div className={cls("formWrapper")}>{children}</div>
      </div>
    </section>
  );
};

export default BenefitsForm;
